import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const userActions = {
    login,
    logout,
    // getAll,
    forgotPassword,
    setPassword,
    setPasswordHandler
};

function setPasswordHandler(data, call, callback) {
    return dispatch => {
        dispatch(request(call));
        userService.setPasswordHandler(data, call)
            .then(
                setPassword => {
                    dispatch(success(setPassword,call));
                    if(callback) {
                        callback(setPassword)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(false)
                    }
                }
            );
    };

    function request(call) { return { type: userConstants.REQUEST_SET_PASSWORD, call: call} }
    function success(setPassword, call) { return { type: userConstants.RECEIVE_SET_PASSWORD, setPassword, call: call } }
    function failure(error) { return { type: userConstants.SET_PASSWORD_ERROR, error } }
}

function login(data) {
    return dispatch => {
        dispatch(request({ data }));

        userService.login(data)
            .then(
                user => { 
                    dispatch(success(user));
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

// function getAll() {
//     return dispatch => {
//         dispatch(request());

//         userService.getAll()
//             .then(
//                 users => dispatch(success(users)),
//                 error => dispatch(failure(error))
//             );
//     };

//     function request() { return { type: userConstants.GETALL_REQUEST } }
//     function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
//     function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
// }

function forgotPassword(data, callback) {
    return dispatch => {
        dispatch(request());
        userService.forgotPassword(data)
            .then(
                forgotPassword => {
                    dispatch(success(forgotPassword));
                    if(callback) {
                        callback(forgotPassword)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userConstants.REQUEST_FORGOT_PASSWORD } }
    function success(forgotPassword) { return { type: userConstants.RECEIVE_FORGOT_PASSWORD, forgotPassword } }
    function failure(error) { return { type: userConstants.FORGOT_PASSWORD_ERROR, error } }
}

function setPassword(callback) {
    return dispatch => {
        dispatch(request());
        userService.setPassword()
            .then(
                setPassword => {
                    dispatch(success(setPassword));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userConstants.REQUEST_SET_PASSWORD } }
    function success(setPassword) { return { type: userConstants.RECEIVE_SET_PASSWORD, setPassword } }
    function failure(error) { return { type: userConstants.SET_PASSWORD_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/user.actions.js